// extracted by mini-css-extract-plugin
export default {"numberFieldset":"numberFieldset---Tinre","legend":"legend---hmStk","preview":"preview---TTcv6","previewImage":"previewImage---gP5Y5"};